import { competitionConfigsService } from '../services/supabase';
import {
  saveVersion,
  saveVersionSuccess,
  saveVersionError,
  loadVersion,
  loadVersionSuccess,
  loadVersionError
} from './competitionSlice';

export const saveCompetitionVersion = (competition, customMessage = null) => async (dispatch) => {
  try {
    dispatch(saveVersion({}));
    const result = await competitionConfigsService.saveVersion(
      competition.competition.id,
      competition
    );
    dispatch(saveVersionSuccess({ ...result, message: customMessage }));
  } catch (error) {
    dispatch(saveVersionError(error.message));
  }
};

export const loadCompetitionVersion = (competitionId, revision) => async (dispatch) => {
  try {
    dispatch(loadVersion());
    const result = await competitionConfigsService.getVersion(competitionId, revision);
    dispatch(loadVersionSuccess(result));
  } catch (error) {
    dispatch(loadVersionError(error.message));
  }
};

export const loadLatestVersion = (competitionId) => async (dispatch) => {
  try {
    dispatch(loadVersion());
    const result = await competitionConfigsService.getLatestVersion(competitionId);
    dispatch(loadVersionSuccess(result));
  } catch (error) {
    dispatch(loadVersionError(error.message));
  }
};
